<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets/images/about/banner.png" />
        <div class="banner-title">客户数据平台</div>
      </div>
      
      <div class="container">
        <img src="@/assets/images/weChat/bs.jpg" class="big-bg"/>
        <div class="wrap-nav">
          <div class="wrap-nav-describe">
             针对未来用户全渠道数据整合与运营的需求，打通第三方电商平台，微信生态，社交生态，企业内部系统间用户数据，建立全景用户画像与标签体系，提高数据价值挖掘与使用率。
          为品牌其他用户运营场景提供有效数据支持。
          </div>
        </div>
        <div class="content">
          <div class="describe">
            <img src="@/assets/images/datePlatform/datePlatform1.png" class="vip-img" />
            <div class="vip-box">
              <p >多渠道数据融合管理</p>
              <p >抓取来自传统终端、POS设备、PC和移动端订购平台以及微信服务号等多个渠道的客户数据，将多个渠道数据进行整合，实现销售闭环。</p>
            </div>
          </div>
          <div class="describe">
            <div class="error-box">
              <p>客户360画像</p>
              <p>基于多渠道的数据整合，可建立客户360画像，包括基础信息、销售特征、行为特征等，使客户拥有更全面的策略与精准营销使用。</p>
            </div>
            <img src="@/assets/images/datePlatform/datePlatform2.png"  class="error-img" />
          </div>
          <div class="describe" >
            <img src="@/assets/images/datePlatform/datePlatform3.png" />
            <div class="ugc-box">
              <p>标签管理</p>
              <p>
               多维度标签管理，各种满足业务需求的预置分组，组合标签以及自定义标签，帮助品牌玩转消费者精细化运营。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 72px"></div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {};
  },
  components: {
    navBar,
    footerBar
  },
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  min-width: $min-screen-width;
  margin: 0 auto;
  font-family: Source Han Sans CN;
  padding-bottom: 72px;
  .banner {
    position: relative;
    height: 430px;
    overflow: hidden;
    .banner-title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 575px;
    }
  }
  .wrap-nav {
    margin: 0 auto;
    margin-top: 58px;
    // width: 1200px;
    position: relative;
    z-index: 10;

    .wrap-nav-describe {
      margin: 0 auto;
      margin-top: 110px;
      text-align: center;
      width: 1012px;
      font-size: $font-size-20;
      line-height: 32px;
      color: #707070;
    }
  }

  p:nth-child(1) {
    font-size: $font-size-20;
    font-weight: bold;
    line-height: 50px;
    color: #464646;
  }
  p:nth-child(2) {
    margin-top: 30px;
    // width: 430px;
    width: 360px;
    font-size: $font-size-18;
    font-family: SourceHanSansCN-Normal;
    line-height: 28px;
    color: #707070;
    opacity: 1;
  }
}

.container {
  height: 2525px;
  position: relative;
  overflow: hidden;
  .big-bg {
    position: absolute;
  }
  .content {
    width: 1200px;
    height: 2525px;
    position: relative;
    margin: 0 auto;
    .describe {
      display: flex;
      margin-top: 200px;
      .vip-box {
        padding-left: 44px;
        padding-top: 80px
      }
      .vip-img{
        margin-left:40px;
        margin-top: -110px;
      }
      .error-box {
        padding-left: 60px;
        margin-right: 60px;
        margin-top: 188px;
      } 
      .error-img {
        margin-top: 90px;
        margin-bottom: 120px;
      }
      .ugc-box {
        padding-top: 90px;
        padding-left: 60px; 
      }
      .last-box {
        padding-left: 59px; 
        padding-right: 278px; 
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/datePlatform/index.vue